export const hasToken = ({ token }) => !!token

export const getUser = ({ user }) => user

export const getPermissions = ({ user }) => user.permissions || []

export const getRoles = ({ user }) => user.roles || []

export const isSuperAdmin = ({ user }) => user.is_super_admin === true

export const hasPermission = ({ user }) => (permission) => {
  if (user.is_super_admin) return true
  return user.permissions && user.permissions.includes(permission)
}

export const hasAnyPermission = ({ user }) => (permissions) => {
  if (user.is_super_admin) return true
  if (!user.permissions) return false
  return permissions.some(perm => user.permissions.includes(perm))
}

export const hasRole = ({ user }) => (role) => {
  return user.roles && user.roles.includes(role)
}
